const getDiscoordenatedWarning = state => {
  let value = ''
  if (state.specialty?.isTherapy) {
    value =
      '<p>O acesso a essa especialidade demanda a exist&ecirc;ncia de um encaminhamento da Aten&ccedil;&atilde;o Prim&aacute;ria.</p> <p>Sugerimos a checagem da elegibilidade do membro antes de agendar seu pr&oacute;ximo atendimento.</p>'
  } else {
    value =
      '<p>Acessos à comunidade sem encaminhamento acarretam em cobrança de coparticipação para o membro.</p> <p> </p> <p>Caso esse atendimento não seja pertinente, sugerimos direcionamento para a Atenção Primária por meio da opção de `Alta`</p>'
  }

  return value
}

export default { getDiscoordenatedWarning }
